<template>
<NetworkStatus v-if="isOffline" />
<div v-else>  
  
   

  <div class="container-fluid">

    <!-- Bannière du certificat de scolarité : invite à configurer, puis
         rappelle qu'on peut modifier avec un aperçu du modèle choisi. -->
    <certificate-banner class="mt-3" />

    <div class="card px-0 mt-3">
      <div class="card-body px-0">
        <div class="row">
          <div class="col-md-6 " style="padding-left: 35px">
             
            <i  class="bi bi-cash-stack fs-3"></i>
          </div>
          <div class="col-md-6 text-end" style="padding-right: 30px">
            <RouterLink to="/create-payment-config" v-if="config.length > 0">
              <argon-button color="success" size="sm" variant="outline">
                <i class="fas fa-plus me-2"></i>
                {{ $t("payment.button_add") }}
              </argon-button>
            </RouterLink>
          </div>
        </div>

        <spinner class="text-center mt-8 mb-8" v-if="loading" style="height: 200px">
          <div>
            <span class="mt-4"><Spinner /></span>
          </div>
        </spinner>

        <table class="table border-0 px-0 mt-6 mb-6" v-else-if="config.length > 0">
          <thead>
            <tr style="border-bottom: 1px solid rgba(255, 255, 255, 0.1);">
              <th scope="col" class="border-0">{{ $t("payment.group") }}</th>
              <th scope="col" class="border-0">{{ $t("payment.grades") }}</th>
              <th scope="col" class="border-0 text-end pe-1 w-10">{{ $t("payment.total_installment") }}</th>
              <th scope="col" class="border-0 w-40 text-end">{{ $t("payment.total_amount") }}</th>
            </tr>
          </thead>
          <tbody>
            <!--
              Une ligne = un groupe de paiement. Un groupe porte plusieurs
              niveaux (grade_code_list) : les tranches et le montant total
              s'appliquent donc à l'ensemble de ces niveaux, et non plus à un
              couple niveau + spécialité comme auparavant.
            -->
            <tr
              v-for="list in config"
              :key="list.id"
              class="config-row"
              :class="{ 'is-incomplete': list.installment_count === 0 }"
              style="position: relative; border-bottom: 1px solid rgba(255, 255, 255, 0.1);"
            >
              <td scope="row" class="px-4 border-0" :title="$t('payment.title_update_payment')">
                <router-link :to="{ name: 'update-config', params: { id: list.id } }">
                  <span class="group-name">{{ list.name || $t("payment.unnamed_group") }}</span>
                  <span class="group-meta d-block">{{ classroomLabel(list) }}</span>
                </router-link>
              </td>

              <!-- Niveaux du groupe, traduits en noms lisibles quand on les connaît -->
              <td class="px-4 border-0">
                <span
                  class="grade-pill"
                  v-for="code in list.grade_code_list || []"
                  :key="code"
                >{{ gradeName(code) }}</span>
                <span class="group-meta" v-if="!(list.grade_code_list || []).length">
                  {{ $t("payment.no_grade_in_group") }}
                </span>
              </td>

              <td class="border-0 text-end position-relative w-10">
                <span
                  class="alert bg-transparent"
                  v-if="list.installment_count === 0"
                  :title="$t('payment.alert')"
                  style="z-index: 1"
                >
                  <i class="bi fs-6 text-warning bi-exclamation-triangle-fill"></i>
                </span>
                {{ list.installment_count }}
              </td>

              <td class="text-end position-relative border-0">
                <span class="amount border-0" style="transform: translateY(-10px);" v-if="list.installment_count > 0">
                  {{ currency_code }}
                  {{ Number(list.total_amount).toLocaleString(this.$i18n.locale === 'fr' ? 'fr-FR' : 'en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0}) }}
                </span>
                <span class="amount border-0 to-define" style="transform: translateY(-10px);" v-else>
                  {{ $t("payment.to_define") }}
                </span>
                <div class="action position-absolute top-0">
                  <router-link :to="{ name: 'detail-config', params: { id: list.id } }">
                    <button class="btn btn-link text-secondary mb-0 text-xl" :title="$t('newpayment.title_icon_add')">
                      <i class="fa fa-plus fs-5 mt-2 text-success" aria-hidden="true"></i>
                    </button>
                  </router-link>
                  <button class="btn btn-link text-secondary mb-0 text-xl" :title="$t('newpayment.title_icon_delete')" @click="confirmDelete(list.id)">
                    <i class="fa fa-trash-alt fs-5 mt-2 text-success" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="else text-center pb-5" v-else>
          <div class="container">
            <div class="text mt-3">
              <img class="image" src="@/assets/img/groupe.png" alt="" />
              <h5 class="mt-4">{{ $t("payment.no_payment_title") }}</h5>
              <p class="mt-4" v-html="$t('payment.no_payment_p')"></p>
              <p class="mt-5">
                <router-link to="/create-payment-config" class="btn w-20 fs-6 text-center bg-gradient-success" style="width: 200px; z-index: 2">
                  <span class="fa fa-plus-circle m-2"></span>
                  {{ $t("payment.button_add") }}
                </router-link>
              </p>
            </div>
          </div> 
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Delete -->
  <div v-if="isDeleteModalOpen" class="modal fade show d-block" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" style="background: rgba(0,0,0,0.4);">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="staticBackdropLabel3"></h5>
            <button type="button" class="btn-close" @click="closeDeleteModal" aria-label="Close"></button>
          </div>
          <div class="modal-body mt-n3 text-center pt-4 pb-4">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
            <h6>{{ $t("payment.modal_delete_title") }}</h6>
            <p class="text-justify px-6">{{ $t("payment.modal_delete_text") }}</p>
          </div>
          <div class="modal-footer border-0 pb-5 mb-1">
            <argon-button type="button" class="btn bg-transparent " @click="closeDeleteModal" style="width: 150px; height: 50px; padding-top: 15px; border:1px solid rgba(255, 255, 255, 0.4);">
              {{ $t("button.cancel") }}
            </argon-button>
            <argon-button :loading="isDeleting" :disabled="isDeleting" color="danger" variant="gradient" type="button" class="mt-1" style="width: 150px; height: 50px; padding-top: 15px; margin-right: 50px;" @click="deleteConfiguration(configToDeleteId)">
              {{ isDeleting ? '' : $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>  
</template>


<script>
import ArgonButton from "@/components/ArgonButton";
import Spinner from "../components/Spinner.vue";
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import CertificateBanner from "@/views/Classroom/CertificateBanner.vue";
import api_config from "@/config";

import {
  getcreateconfig,
  deleteConfig,
  getCreateConfigDetails,
  deleteInstallment,
  getGrades,
} from "@/utils/services";
import { ref, onMounted } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  name: "payment-config",
  components: { ArgonButton, Spinner, NetworkStatus, CertificateBanner },
  data() {
    return {
      grade_list: [],
      grade_code: "",
      installment_count: "",
      total_amount: "",
      installment_list: [],
      showCustomDiv: false,
      isDeleteModalOpen: false,
      configToDeleteId: null,
      buttonActive: false,
      showConfirmation: false,
      isOffline: false,  
      apiError: false, 
      currency_code: api_config.CURRENCY_CODE,
      isDeleting: false,
      
    };
  },

  async mounted() {
    // Initialiser l'état de connexion au montage
   
    this.fetchConfig;

    // Ajouter les event listeners pour les changements de réseau
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.intervalId = setInterval(this.checkInternetConnection, 1000);
    

    // Charger les données initiales
    if (!this.isOffline) {
      
       this.fetchConfig;
    }
  },

  

 
  beforeUnmount() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

   
   
  methods: {
    /**
     * Nom lisible d'un niveau. L'API renvoie des codes (« CIN ») : on les
     * traduit via /api/grades. Si la correspondance manque, on affiche le
     * code plutôt que rien.
     */
    gradeName(code) {
      return this.gradeNames[code] || code;
    },
    /**
     * Nombre de classes couvertes par le groupe.
     *
     * On additionne les classes de chaque niveau du groupe, d'après
     * /api/grades — la même source que le sélecteur de l'écran de création,
     * donc les deux écrans annoncent le même chiffre.
     *
     * `list.classrooms` n'est pas utilisé : l'API le renvoie vide même pour
     * des niveaux qui contiennent des classes.
     */
    classroomCount(list) {
      return (list.grade_code_list || []).reduce(
        (total, code) => total + (this.gradeClassrooms[code] || []).length,
        0
      );
    },
    classroomLabel(list) {
      const count = this.classroomCount(list);
      if (count) return this.$t("payment.classroom_count", { count });
      return this.$t("payment.no_classroom_yet");
    },

    async updateOnlineStatus() {
    // Vérifier si le navigateur est en ligne
    if (navigator.onLine) {
      try {
        // Vérifier si les API sont accessibles
        await this.checkConnection();
        this.isOffline = false; // Tout fonctionne, on est en ligne
      } catch (error) {
        console.error("Error checking connection:", error);
        this.isOffline = true; // Les API ne répondent pas, on est hors ligne
      }
    } else {
      // Pas de connexion internet détectée
      this.isOffline = true;
    }
  },

  async checkConnection() {
    try {
      // Essayer les deux appels API
      await Promise.all([
      getcreateconfig()
         
      ]);
      this.apiError = false; // Les API répondent correctement
    } catch (error) {
      console.error("API Error:", error);
      this.apiError = true; // Les API ne répondent pas
    }
  },

    getObject(grade) {
      this.grade_code = grade.grade_code;
      this.installment_count = grade.installment_list.length;
      this.total_amount = grade.total_amount;
      this.installment_list = grade.installment_list;
    },

    confirmDelete(configId) {
      this.configToDeleteId = configId;
      this.isDeleteModalOpen = true;
    },
    closeDeleteModal() {
      this.isDeleteModalOpen = false;
      this.configToDeleteId = null;
      this.isDeleting = false;
    },
    async deleteConfiguration(configId) {
      try {
        if (this.isDeleting) {
          return;
        }
        this.isDeleting = true;
        this.loading = true;
        const config = await getCreateConfigDetails();
        const deleted = await deleteConfig(configId);
        if (deleted) {
          this.showConfirmation = true;
          const message = this.$t("payment.success_message");
          toast.success(message, { autoClose: 3000 });
          if (config && config.installment_list) {
            for (const installment of config.installment_list) {
              await deleteInstallment(installment.id);
            }
          }
          setTimeout(() => {
            this.showConfirmation = false;
            this.closeDeleteModal();
            window.location.reload();
          }, 3000);
        }
      } catch (error) {
        console.error("Error while deleting configuration:", error);
        this.isDeleting = false;
      } finally {
        this.loading = false;
      }
    },
  },



  setup() {
    const config = ref([]);
    const loading = ref(false);
    /* Correspondance code de niveau → nom lisible : { CIN: "5ème" } */
    const gradeNames = ref({});
    /* Classes par niveau : { CIN: [{ speciality_code: "ESP" }, …] } */
    const gradeClassrooms = ref({});

    const fetchGrades = async () => {
      try {
        const grades = await getGrades();
        const names = {};
        const rooms = {};
        ((grades && grades.data) || []).forEach((grade) => {
          if (!grade.code) return;
          names[grade.code] = grade.name;
          rooms[grade.code] = grade.classrooms || [];
        });
        gradeNames.value = names;
        gradeClassrooms.value = rooms;
      } catch (error) {
        // Sans cette correspondance on affichera les codes bruts : moins
        // lisible, mais l'écran reste utilisable.
        console.error("Erreur lors de la récupération des niveaux :", error);
      }
    };

    const fetchConfig = async () => {
      try {
        loading.value = true;
        const result = await getcreateconfig();

        if (result.status === 200) {
          // Initialiser showCustomDiv à false pour chaque élément de la liste
          config.value = result.data.map((item) => ({
            ...item,
            showCustomDiv: false,
          }));
          this.showModal = true;
        } else {
          console.error(
            "Erreur lors de la récupération des membres :",
            result.error
          );
        }
      } catch (error) {
        console.error(
          "Erreur inattendue lors de la récupération des membres :",
          error
        );
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchConfig();
      fetchGrades();
    });

    return {
      config,
      loading,
      gradeNames,
      gradeClassrooms,
    };
  },
};
</script>

<style scoped>


/*=======css table ====*/
.else .image {
  width: 300px;
  margin-top: 10px;
}
.card .table thead th {
  width: 30%;
}
.card .table tbody tr  td .amount {
   position: absolute;
   right: 20px;
 
}

.card .table tbody tr:hover td .amount {
  filter: blur(2px);
 
}
.card .table tbody tr {
  transition: 0.7s;
  cursor: pointer;
}
.action {
  display: none;
  right:0;
}
.card .table tbody tr:hover .action {
  display: block;
}

.table tbody tr td {
  padding-top: 13px;
  padding-bottom: 13px;
}

table tbody tr:hover td .button {
  display: block;
}
.table tbody tr:hover td .amount p {
  filter: blur(2px);
  
}

.table thead tr th {
  width: 20%;
}

.td-warning {
  position: relative;
}

.warning {
  font-size: 20px;
  position: absolute;
  right: 90px;
  top: 6px;
}

.text-warning1 {
  background: white;
  color: black;
  position: absolute;
  top: -45px;
  right: 100px;
  padding: 15px 30px;
}

/*=======css table ====*/

.custom-div {
  position: absolute;
  background-color: white;
  padding: 10px;
  border: 1px solid #d4d4d4;
  border-radius: 5px;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  display: none;
  margin-bottom: -30px; /* Ajoutez cette ligne pour compenser le déplacement vers le haut */
  margin-left: -10px; /* Ajoutez cette ligne pour compenser le déplacement vers la gauche */
}

.custom-div-active {
  display: block;
}

/*=======css modal ====*/
.modal {
  background: rgba(0, 0, 0, 0.4);
}
.modal .modal-dialog {
  max-width: 55%;
  width: 55;
  margin-left: 30%;
}

.modal .modal-dialog .modal-content {
  background: transparent;
}
.t-titre {
  width: max-content;
  margin-left: 4%;
}
.table tbody tr td {
  padding-top: 13px;
  padding-bottom: 13px;
 
}

table tbody tr:hover td .button {
  display: block;
}
.table tbody tr:hover td .amount p {
  filter: blur(2px);
}
.table tbody tr:hover td .alert {
  filter: blur(4px);
}
.table thead tr th {
  width: 20%;
}

.td-warning {
  position: relative;
}

.warning {
  font-size: 20px;
  position: absolute;
  right: 90px;
  top: 6px;
}

.text-warning1 {
  background: white;
  color: black;
  position: absolute;
  top: -45px;
  right: 100px;
  padding: 15px 30px;
}

@media (max-width: 767px) {
  .card .card-body .table-responsive {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .modal .modal-dialog {
    max-width: 90%;
    width: 90%;
    margin-left: 5%;
    height: 80%;
  }

  .t-titre {
    width: max-content;
    margin-left: 0%;
  }
  .card .table tbody .else .button-else {
    display: none;
  }
}

@media (min-width: 768px) {
  .card .card-body .table-responsive {
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

.modal.fade.show.d-block {
  display: block;
  background: rgba(0,0,0,0.4);
  z-index: 1050;
}

/* --- Liste des groupes de paiement -------------------------------------- */

.group-name {
  font-size: 14px;
  font-weight: 600;
}

.group-meta {
  font-size: 11.5px;
  opacity: 0.55;
  line-height: 1.4;
}

/* Un niveau = une pastille. Un groupe en portant plusieurs, la liste se
   lit d'un coup d'œil là où une colonne texte les aurait concaténés. */
.grade-pill {
  display: inline-block;
  font-size: 11px;
  padding: 2px 9px;
  margin: 2px 4px 2px 0;
  border-radius: 999px;
  border: 1px solid rgba(46, 206, 191, 0.35);
  background: rgba(46, 206, 191, 0.1);
  color: #2ecebf;
  white-space: nowrap;
}

/* Groupe sans tranche : inutilisable en l'état, on le signale sur toute la
   ligne plutôt que par une icône visible au seul survol. */
.config-row.is-incomplete {
  background: rgba(251, 191, 36, 0.06);
}

.to-define {
  font-size: 12.5px;
  opacity: 0.6;
  font-weight: 400;
}



</style>